// extracted by mini-css-extract-plugin
export var baseButton = "_oo-0";
export var controlsArrowKeys = "_oo-1";
export var controlsResetButton = "_oo-2";
export var lightGameButton = "_oo-4 _oo-0";
export var playAgainButton = "_oo-5 _oo-0";
export var startGameButton = "_oo-3 _oo-0";